import React, { FC } from 'react';
import classnames from 'classnames';
import { ApplicantsSortOptionEnum } from '@src/graphql/generated';
import { useQueryParams } from '@src/customHooks/useQueryParams';
import { trackEvent } from '@src/metrics';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { QueryParams } from '../../interfaces/queryParams.interface';
import './styles.scss';

const SORT_OPTIONS = [
  {
    label: 'Applied at',
    value: ApplicantsSortOptionEnum.USER_APPLIED_AT,
  },
  {
    label: 'Last message',
    value: ApplicantsSortOptionEnum.LATEST_MESSAGE,
  },
];

export const InConversationHeader: FC = () => {
  const { queryParams, updateQueryParams } = useQueryParams<QueryParams>();

  const sortOption = queryParams.inConversationUsersSortOption || ApplicantsSortOptionEnum.USER_APPLIED_AT;

  const onSort = (inConversationUsersSortOption: ApplicantsSortOptionEnum): void => {
    updateQueryParams({ inConversationUsersSortOption: inConversationUsersSortOption });
    trackEvent({
      context: MetricContext.OPENING_VIEW,
      interaction: MetricAction.SORT_FEED,
      payload: {
        'Sort Option': inConversationUsersSortOption,
      },
    });
  };

  return (
    <div className="opening-in-conversation-header">
      <div className="opening-in-conversation-header__text">
        <div className="opening-in-conversation-header__title">In conversation</div>

        <div className="opening-in-conversation-header__description">
          Direct and invited talent who have started a conversation with you about this position
        </div>
      </div>

      <div className="opening-in-conversation-header__sorting-wrapper">
        <span className="opening-in-conversation-header__sort-by">Sort by:</span>
        <div className="opening-in-conversation-header__sorting">
          {SORT_OPTIONS.map(option => {
            return (
              <div
                className={classnames(
                  'opening-in-conversation-header__sorting-option',
                  sortOption === option.value && 'opening-in-conversation-header__sorting-option--active',
                )}
                key={option.value}
                onClick={() => onSort(option.value)}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
